import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "bp-badge",
	templateUrl: "./bp-badge.component.html",
	styleUrls: ["./bp-badge.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpBadgeComponent {
	@Input() public variant: "brand" | "neutral" | "ghost";
	@Input() public size: "small" | "medium";
}
